import {
  enhancedMakeFetchAction,
  generateEndpoint
} from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

const FETCH_DATA_LIST_API_ID = 'EMPLOYEE/FETCH_INVESTCORE_BANKS'

const apiCall = enhancedMakeFetchAction(FETCH_DATA_LIST_API_ID, params => ({
  endpoint: generateEndpoint({
    host: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/banks`,
    params
  }),
  method: 'GET'
}))

export default apiCall
